/**
 * The smelter (ADR 0018): five identical pieces melted into one of the next
 * rarity, in every village.
 */
/** How many identical pieces make one of the next rarity. */
export const FUSION_COUNT = 5;
/** The monster who keeps the foundry (`data/mobs.ts`). */
export const SMELTER_MOB_ID = 'smelter';
/** How close to a smelter a player must stand, in tiles, diagonals included. */
export const SMELTER_REACH = 2;
//# sourceMappingURL=fusion.js.map